import Prismic from "@prismicio/client";
var apiEndpoint = "https://netdata-news.cdn.prismic.io/api/v2";
var client = Prismic.client(apiEndpoint);
export var fetchNews = function (app, onSuccess, onError) {
    return client
        .query(Prismic.Predicates.at("document.tags", [app]), {
        pageSize: 100,
        orderings: "[document.last_publication_date desc]",
    })
        .then(onSuccess)
        .catch(onError);
};
